import { render, staticRenderFns } from "./AddManually.vue?vue&type=template&id=18fa96e0&"
import script from "./AddManually.vue?vue&type=script&lang=js&"
export * from "./AddManually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports